if (!customElements.get('view-switcher')) {
  class ViewSwitcher extends HTMLElement {
    constructor() {
      super();
      this.CollectionFiltersForm = document.querySelector('product-filters-form');
      this.buttons = this.querySelectorAll('[data-switch-view]');
      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.handleButtonClick(button);
        });
      });
    }
    handleButtonClick(button) {
      // Get full current url
      const url = new URL(window.location);
      let params = new URLSearchParams(url.search);
      // Delete view first by default
      params.delete('view');
      const view = button.dataset.switchView;
      // Update view param when not empty
      if (view != '') {
        params.set('view', view);
      }

      if (this.CollectionFiltersForm) {
        // Render the page again with method from collection filters form component
        this.CollectionFiltersForm.renderPage(params.toString());
      } else {
        // Update the URL with the new parameters and reload the page
        url.search = params.toString();
        window.location.href = url.toString();
      }

      // Reset UI state classes on buttons
      this.buttons.forEach((button) => {
        button.classList.remove(
          'collection-layout__button--active',
          'button--green',
          'button--disabled'
        );
        button.classList.add('button--white');
      });
      // Set active state on button
      button.classList.add(
        'collection-layout__button--active',
        'button--disabled',
        'button--green'
      );
      button.classList.remove('button--white');
    }
  }
  customElements.define('view-switcher', ViewSwitcher);
}
